export enum RoutePath {
  Client = '/my-area',
  ClientAddresses = '/my-area/addresses',
  ClientPkg = '/my-area/packages',
  ClientPkgUnite = '/my-area/packages/unite',
  ClientPkgReturn = '/my-area/packages/return',
  ClientProfile = '/my-area/profile',
  ClientProfilePersonal = '/my-area/profile/personal',
  ClientProfileAddresses = '/my-area/profile/addresses',
  ClientProfileAffiliate = '/my-area/profile/affiliate',
  Login = '/login',
  ForgotPassword = '/forgot-password',
  ReceiptUpload = '/receipt-upload',
  PaymentShipping = '/payment/shipping',
  PaymentSummary = '/payment/summary',
  PaymentProcess = '/payment/process',
  Welcome = '/welcome',
}

export enum OfficeRoutePath {
  UserPage = '/office-e&u/eau-userPage',
  ScanPickupOrders = '/office-scan-orders',
  DelayedPackages = '/office/delayed-packages',

  AdminSettings = '/office/admin/settings',
  AdminData = '/office/admin/data',
  AffiliateManager = '/office/admin/affiliate-manager',
}
